export default __webpack_public_path__ + "static/about-us-2-6e6ef386c0b14c653794163ffc87b5c2.webp";